// extracted by mini-css-extract-plugin
module.exports = {"complete-icon":"complete-icon___52G7","icon":"icon__Hd9BT"};